import React, { useMemo } from 'react';

import {
  Popover,
  Grid,
  InfoOutlinedIcon,
  Typography,
  View,
  makeStyles,
} from '@gogame/components';

import { MarksStatistic } from './MarksStatistic';

const useStyles = makeStyles(() => ({
  root: {
    width: '270px',
    padding: '16px',
  },
}));

const AverageRating = ({ rating, data, isLoading }) => {
  const classes = useStyles();

  const subText = useMemo(() => {
    if (!data?.length) {
      return 'No reviews';
    }
    return `${data?.length} ${data?.length === 1 ? 'review' : 'reviews'}`;
  }, [data?.length]);

  return (
    <Popover
      hover={true}
      anchor={<InfoOutlinedIcon sx={{ fontSize: 18 }} color={'action'} />}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'right',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'left',
      }}
    >
      <Grid container className={classes.root}>
        <Grid item>
          <Typography variant={'subtitle1'} gutterBottom={true}>
            Average Rating
          </Typography>
        </Grid>
        <Grid item container spacing={3} alignItems={'center'}>
          <Grid item style={{ flex: '1 1 auto' }}>
            <View loading={isLoading} transparent={true}>
              <MarksStatistic data={data} />
            </View>
          </Grid>
          <Grid item>
            <Grid
              container
              direction={'column'}
              alignItems={'center'}
              justifyContent={'center'}
            >
              <Grid item>
                <Typography variant={'h5'}>{rating}</Typography>
              </Grid>
              <Grid item>
                <Typography variant={'caption'} color={'textSecondary'}>
                  {subText}
                </Typography>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Popover>
  );
};

export default AverageRating;
